export interface LabelBox { x: number; y: number; width: number; height: number; }
const overlaps = (a: LabelBox, b: LabelBox) =>
  a.x < b.x + b.width + 6 && a.x + a.width + 6 > b.x &&
  a.y < b.y + b.height + 6 && a.y + a.height + 6 > b.y;

// Search outwards from each marker, keeping labels inside the visible map.
export function placeFleetLabel(anchor: { x: number; y: number }, width: number, height: number,
  occupied: LabelBox[], bounds: { x: number; y: number }): LabelBox {
  const clamp = (value: number, limit: number) => Math.max(6, Math.min(value, limit - 6));
  let candidate: LabelBox = { x: 0, y: 0, width, height };
  for (let ring = 0; ring < occupied.length + 20; ring++) {
    const distance = 18 + ring * (height + 10);
    for (const [dx, dy] of [[0, -1], [1, -1], [-1, -1], [1, 0], [-1, 0], [0, 1], [1, 1], [-1, 1]]) {
      candidate = {
        x: clamp(anchor.x + dx * (width / 2 + distance) - width / 2, bounds.x - width),
        y: clamp(anchor.y + dy * distance - (dy < 0 ? height : dy === 0 ? height / 2 : 0), bounds.y - height),
        width, height,
      };
      if (!occupied.some(box => overlaps(candidate, box))) return candidate;
    }
  }
  return candidate;
}
